import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class PermissionService {
    private userRoles: { id: number; name: string }[] = [];

    private permissions = new Map<string, string[]>([
        ['SuperAdmin', ['create', 'edit', 'delete', 'view']],
        ['Admin', ['create', 'edit', 'delete', 'view']],
        ['Internal System Admin', ['create', 'edit', 'delete', 'view']],
        ['Support Supervisor', ['view', 'create', 'edit', 'delete']],
        ['Support', ['view']]
    ]);

    setRoles(roles: { id: number; name: string }[]): void {
        this.userRoles = roles;
    }

    canPerform(action: string): boolean {
        return this.userRoles.some((role) => this.permissions.get(role.name)?.includes(action));
    }
}
